import styled from '@emotion/styled';

import { Button } from '../../Button/Button';
import { font } from '../../Font/Font.styles';
import { InputField } from '../../Form/components/InputField/InputField';
import { Form } from '../../Form/Form';
import { Error } from '../../Form/Form.styles';
import { Heading } from '../../Heading/Heading';

export const Wrapper = styled.div`
  border-color: var(--color-neutral-40);
  border-width: 1px;
  border-top-style: solid;
  padding-block: var(--spacing-32);
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--spacing-16);
  max-width: 528px;

  @media (min-width: 600px) {
    align-items: center;
  }
`;

export const StyledHeading = styled(Heading)`
  text-align: left;

  @media (min-width: 600px) {
    text-align: center;
  }
`;

export const StyledParagraph = styled.p`
  ${font('body-lg')}
  color: var(--color-neutral-70);
  text-align: left;

  @media (min-width: 600px) {
    text-align: center;
  }
`;

export const StyledForm = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 600px) {
    flex-direction: row;
  }
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
`;

export const StyledInput = styled(InputField)`
  margin-top: 0;
  height: var(--spacing-48);

  @media (min-width: 600px) {
    width: 353px;
  }
`;

export const StyledError = styled(Error)`
  margin-top: 0;
`;

export const StyledButton = styled(Button)`
  height: var(--spacing-48);
`;
